export default __webpack_public_path__ + "static/media/top-ten-block-5.2e628e06.svg";